import type { Offer } from "./types";

export const seedOffers: Offer[] = [
  {
    id: "quick-survey",
    slug: "quick-consumer-survey",
    title: "Quick Consumer Survey",
    shortDescription: "Answer a few questions about your shopping habits.",
    rewardCents: 125,
    destinationUrl: "https://example.com/offers/quick-survey",
    status: "active",
    priority: 90,
    estimatedMinutes: 5,
    quickWin: true,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["Quick win", "No purchase required"],
    ctaLabel: "Start survey",
    completionTerms: "Complete and submit the survey with valid responses.",
    creditTimingCopy: "Usually confirms within a few minutes.",
  },
  {
    id: "home-quote",
    slug: "free-home-quote",
    title: "Free Home Quote",
    shortDescription: "Request a free quote from one of our featured partners.",
    rewardCents: 300,
    destinationUrl: "https://example.com/offers/home-quote",
    status: "active",
    priority: 100,
    estimatedMinutes: 3,
    quickWin: false,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["No purchase required"],
    ctaLabel: "Earn $3",
    completionTerms: "Submit a complete, truthful quote request. No purchase is required.",
    creditTimingCopy: "Confirmation may take up to 24 hours.",
  },
  {
    id: "free-account",
    slug: "create-free-account",
    title: "Create a Free Account",
    shortDescription: "Create a free account with our featured partner.",
    rewardCents: 250,
    destinationUrl: "https://example.com/offers/free-account",
    status: "active",
    priority: 80,
    estimatedMinutes: 4,
    quickWin: true,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: true,
    badges: ["Free", "Quick win"],
    ctaLabel: "Earn $2.50",
    completionTerms: "Create and verify a new partner account.",
    creditTimingCopy: "Usually confirms within one hour.",
  },
  {
    id: "featured-app",
    slug: "featured-app",
    title: "Try a Featured App",
    shortDescription: "Download the featured app and complete the required signup.",
    rewardCents: 500,
    destinationUrl: "https://example.com/offers/featured-app",
    status: "active",
    priority: 60,
    estimatedMinutes: 10,
    quickWin: false,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "mobile",
    newUsersOnly: false,
    badges: ["Mobile"],
    ctaLabel: "Earn $5",
    completionTerms: "Install the app and complete the required new-user signup.",
    creditTimingCopy: "Confirmation may take up to 24 hours.",
  },
  {
    id: "insurance-options",
    slug: "compare-insurance-options",
    title: "Compare Insurance Options",
    shortDescription: "Complete a short form to compare available insurance options.",
    rewardCents: 400,
    destinationUrl: "https://example.com/offers/insurance-options",
    status: "active",
    priority: 70,
    estimatedMinutes: 5,
    quickWin: false,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["No purchase required"],
    ctaLabel: "Earn $4",
    completionTerms: "Submit a complete, truthful comparison form.",
    creditTimingCopy: "Confirmation may take up to 24 hours.",
  },
  {
    id: "featured-trial",
    slug: "featured-trial",
    title: "Start a Featured Trial",
    shortDescription: "Start a trial with one of our participating partners.",
    rewardCents: 800,
    destinationUrl: "https://example.com/offers/featured-trial",
    status: "active",
    priority: 50,
    estimatedMinutes: 5,
    quickWin: false,
    purchaseRequired: true,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["Trial"],
    ctaLabel: "Earn $8",
    completionTerms: "Start an eligible new trial and satisfy the partner requirements.",
    creditTimingCopy: "Confirmation may take up to 48 hours.",
  },
  {
    id: "newsletter",
    slug: "free-newsletter",
    title: "Join a Free Newsletter",
    shortDescription: "Sign up for a featured newsletter.",
    rewardCents: 75,
    destinationUrl: "https://example.com/offers/newsletter",
    status: "active",
    priority: 95,
    estimatedMinutes: 2,
    quickWin: true,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["Quick win", "Free"],
    ctaLabel: "Earn $0.75",
    completionTerms: "Join with a valid email and confirm the subscription.",
    creditTimingCopy: "Usually confirms within a few minutes.",
  },
  {
    id: "check-options",
    slug: "check-your-options",
    title: "Check Your Options",
    shortDescription: "Complete a short eligibility form with a participating financial partner.",
    rewardCents: 600,
    destinationUrl: "https://example.com/offers/check-options",
    status: "active",
    priority: 40,
    estimatedMinutes: 5,
    quickWin: false,
    purchaseRequired: false,
    repeatability: "one_time",
    deviceEligibility: "all",
    newUsersOnly: false,
    badges: ["Featured"],
    ctaLabel: "Earn $6",
    completionTerms: "Submit a complete eligibility form. Approval is not required for credit.",
    creditTimingCopy: "Confirmation may take up to 24 hours.",
  },
];
